module.exports = __webpack_public_path__ + "img/rank2025.829ca27a.png";